/**
 * @module Helpers/Combo
 * @desc Combo Helpers
 */

import type { Combo } from 'core/domains';

/**
 * Can add combo validate
 *
 */

export function canAddCombo(state: Combo) {
  const {
    data: { available, choices },
  } = state;
  const isComplete = choices.map((choice) => {
    const selectedAmount = choice.items.reduce((sum, { quantity }) => sum + quantity, 0);

    return selectedAmount === choice.totalQuantity;
  });

  return !available || !isComplete.includes(false);
}
